import { createLogger, setNamedItemCatalog, type NamedItemDefinition } from '@sorrem/shared';
import { useEffect, useState } from 'react';
import { useGetNamedItemsQuery } from '@sorrem-client/ui/store';

const logger = createLogger('client:named-item-catalog');

export interface NamedItemCatalogState {
    readonly namedItems: readonly NamedItemDefinition[];
    /** True once the catalog is in this page's shared catalog (or failed to load, so the page goes on without it). */
    readonly isReady: boolean;
}

/**
 * Loads every named item (`GET /api/named-items`) into this page's shared
 * catalog (`setNamedItemCatalog`), which item cards, crafting previews and
 * the game read named copies from. Reloads it whenever the designer saves.
 */
export function useNamedItemCatalog(isSkipped = false): NamedItemCatalogState {
    const { data, error } = useGetNamedItemsQuery(undefined, { skip: isSkipped });
    const [applied, setApplied] = useState<readonly NamedItemDefinition[] | null>(null);

    useEffect(() => {
        if (data) {
            setNamedItemCatalog(data);
            setApplied(data);
        }
    }, [data]);

    useEffect(() => {
        if (error) {
            logger.error('named items did not load; named copies show as their base items:', error);
        }
    }, [error]);

    return { namedItems: applied ?? [], isReady: isSkipped || applied !== null || error !== undefined };
}
